import { Factory } from '@infodata-group/inf-commons';
import { AbsenceType } from '../model/absence-type';
import { AbsenceTypeGroup } from '../model/absence-type-group';

export class AbsenceTypeFactory implements Factory<AbsenceType> {
  build(o: any): AbsenceType {
    const group = new AbsenceTypeGroup(o.type, o.type, null, null, null);
    const category = new AbsenceType(
      o.id,
      o.label,
      group,
      o.color,
      o.borderColor,
    );
    category.inBalance = o.inBalance;
    category.defaultHoursCount = o.defaultHoursCount;
    if (o.message) {
      category.message = o.message;
    }
    return category;
  }

  getApi(): string {
    return 'code-absence';
  }
}
